import React, {Dispatch, useEffect, useState, useMemo} from 'react'
import {Link, useParams, useHistory} from 'react-router-dom'
import Select, {components} from 'react-select'
import {KTSVG} from '../../../../_metronic/helpers'
import {IconTooltip} from '../../../common/components/IconTooltip'
import {WorkOrderClient, WorkOrderQueryParams} from '../../../infrastracture/api/WorkOrderClient'
import {TenantTypeIds} from '../../../common/constants/tenantTypeIds'
import {CONTRACTOR_RESTRICTED_WORK_ORDER_STATUSES} from '../../../common/constants/workOrderStatusNames'
import {connect, shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import AttachmentsList from '../../attachments/components/AttachmentsList'
import QuotesList from '../../quotes/components/QuotesList'
import QuotesListLegacy from '../../quotes/components/QuotesListLegacy'
import NotesList from '../../notes/components/NotesList'
import ReviewsList from '../../reviews/components/ReviewsList'
import ParticipantsList from '../../participants/components/ParticipantsList'
import AssignToModal from './AssignToModal'
import CheckInsList from '../../check-ins/components/CheckInsList'
import DueDateModal from './Modals/DueDateModal'
import DueDateAuditModal from './Modals/DueDateAuditModal'
import ExpectedOnSiteModal from './Modals/ExpectedOnSiteModal'
import ExpectedOnSiteAuditModal from './Modals/ExpectedOnSiteAuditModal'
import Moment from 'react-moment'
import moment from 'moment'
import NoticeSitesList from '../../notice-sites/components/NoticeSitesList'
import WorkOrderHistoryList from '../../work-order-history/components/WorkOrderHistoryList'

import ChargesList from '../../charges/components/ChargesList'
import {toMoneyFormat} from '../../../common/helpers/stringHelper'
import WorkOrderStatusUpdateSelector from '../../../common/components/selectors/WorkOrderStatusUpdateSelector'
import {
  CategoryWorkScopesClient,
  CategoryWorkScopesQueryParams,
} from '../../../infrastracture/api/CategoryWorkScopesClient'
import {OverlayTrigger, Popover, Spinner, Tooltip} from 'react-bootstrap-v5'
import SiteCheckList from './SiteCheckList'
import {
  WorkOrderStatusClient,
  WorkOrderStatusQueryParams,
} from '../../../infrastracture/api/WorkOrderStatusClient'
import toast, {Toaster} from 'react-hot-toast'
import WorkOrderChildren from './WorkOrderChildren'
import WorkOrderAssetsList from './WorkOrderAssetsList'
import {Actions} from '../redux/WorkOrderRedux'
import {SweetAlertWithProp} from '../../../../SweetAlertWithProp'
import WorkOrderMessageModal from './WorkOrderMessageModal'
import {Permissions} from '../../../common/constants/permissions'
import MessagesList from '../../messages/components/MessagesList'
import {TenantsClient} from '../../../infrastracture/api/TenantsClient'
import QuotesModal from '../../quotes/components/QuotesModal'
import {
  ClientPrioritySettingsClient,
  ClientPrioritySettingsQueryParams,
} from '../../../infrastracture/api/ClientPrioritySettingsClient'
import WorkOrderProjectCostModal, {formatWorkOrderDisplay} from './WorkOrderProjectCostModal'
import WorkOrderProjectCostModalLegacy from './WorkOrderProjectCostModalLegacy'
import QuotesForParentWorkOrderList from '../../quotes/components/QuotesForParentWorkOrderList'
import QuotesForParentWorkOrderListLegacy from '../../quotes/components/QuotesForParentWorkOrderListLegacy'
import {ProjectsClient} from '../../../infrastracture/api/ProjectsClient'
import AsyncSelect from 'react-select/async'
import ReadyIndicator from './widgets/ReadyIndicator'
import BulkUploadModal from './BulkUploadModal'

interface Props {
  dispatch: Dispatch<any>
  workorder: any
}

export enum NavItems {
  Notes,
  Quotes,
  Attachments,
  Assignments,
  Reviews,
  Participants,
  CheckIns,
  Notices,
  Charges,
  WorkOrderHistoryList,
  CheckLists,
  Children,
  Assets,
}

const WorkOrderDetails: React.FC<Props> = ({dispatch, workorder}) => {
  const params: any = useParams()
  const history = useHistory()

  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as any

  const permissions: any = useSelector<RootState>(
    ({auth}) => auth.userPermission,
    shallowEqual
  ) as any

  const [supplierStatus, setSupplierStatus] = useState<any>({})
  const [supplierStatusLoading, setSupplierStatusLoading] = useState<boolean>(false)

  const [externalId, setExternalId] = useState<any>({})
  const [workOrder, setWorkOrder] = useState<any>({})
  const enableQuoteSummary = workOrder?.tenant?.enableQuoteSummary ?? false
  const [loading, setLoading] = useState<boolean>(false)
  const [selectedChildWorkOrder, setSelectedChildWorkOrder] = useState<any>(null)
  const [childWorkOrders, setChildWorkOrders] = useState<any[]>([])
  const [loadingChildWorkOrders, setLoadingChildWorkOrders] = useState<boolean>(false)
  const [categoryWorkScope, setCategoryWorkScope] = useState<any>(null)
  const [WorkOrderStatus, setWorkOrderStatus] = useState<Array<any>>([])
  const [selectedWorkOrderStatusId, setSelectedWorkOrderStatusId] = useState('')
  const [onChangeFlag, setOnChangeFlag] = useState<boolean>(false)
  const [prevWorkOrderStatus, setPrevWorkOrderStatus] = useState<any>({})
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalRecords: 1,
    totalPages: 1,
    skip: 0,
    take: 50,
    reset: true,
    sort: 'name',
    direction: 'asc',
  })
  const [projectCost, setProjectCost] = useState(0)
  const [imageLogo, setImageLogo] = useState('')
  const [refreshQuotesList, setRefreshQuotesList] = useState(false)
  const [showProjectCostModal, setShowProjectCostModal] = useState(false)
  const [showAssignToProjectModal, setShowAssignToProjectModal] = useState(false)
  const [cwoCount, setCwoCount] = useState(0)

  const {filter} = workorder
  const {selectedTab} = filter

  useEffect(() => {
    fetchData().then(() => {})
    fetchWorkOrderStatusData().then(() => {})
  }, [params])

  const sourceFriendlyName = (name: string) => {
    if (name === 'error') return 'error'
    if (name === 'none') return 'none'
    if (name === 'tenant') return 'client'
    if (name === 'onBehalfOfTenant') return 'on behalf of'
    if (name === 'department') return 'department'
    if (name === 'workOrder') return 'override'
    if (name === 'existingSyncRelationship') return 'pinned'

    return 'unknown'
  }

  const updateProjectId = async (values: any) => {
    let response = await ProjectsClient.GetProjectIdForWorkOrder(values.id)
    console.log(response)
    if (response.successful) {
      setExternalId(response.data)
    } else {
      setExternalId({source: 'error'})
    }
  }

  const loadOptions = async (inputValue: string, callback: (options: any) => void) => {
    let params = new WorkOrderQueryParams()
      .WithIgnoreCompleteOnly(true)
      .Search(inputValue)
      .WithTenantId(workOrder.tenant.id)
      .IsParent()

    let projectWorkOrders = await WorkOrderClient.List(params)

    let options = projectWorkOrders.data.data.map((item: any) => {
      return {
        value: item.id,
        item: item,
        label: item.workOrderNumber,
      }
    })

    callback(options)

    return options
  }

  const formatOptionLabel = ({_, label, item}: any) => (
    <div>
      <div>
        <strong>{label}</strong>
      </div>
      <div>{item.description}</div>
    </div>
  )

  const fetchData = async () => {
    setLoading(true)
    let response = await WorkOrderClient.Get(params.id)

    if (response.successful) {
      const {data} = response

      await updateProjectId(data)

      if (data.workOrderCategoryId && data.workScopeId) {
        await getCategoryWorkScope(data.workOrderCategoryId, data.workScopeId)
      }
      setWorkOrder(data)
      setPrevWorkOrderStatus(data.workOrderStatus)

      let totalProjectCost = data.cost || 0

      if (data.childrenWorkOrder.length > 0) {
        const childrenCost = data.childrenWorkOrder.reduce(
          (n: any, {cost}: any) => n + (cost ? cost : 0),
          0
        )
        totalProjectCost += childrenCost
      }
      setLoading(false)
      if (data.isParent && data.tenant?.enableQuoteSummary) {
        // New flow: modal calculates from quotes/charges
      } else {
        setProjectCost(totalProjectCost)
      }

      setImageLogo(data.tenant?.logo)

      console.log('Checking WO')
      console.log(data)
      await checkSupplierStatus(data)

      let query = new WorkOrderQueryParams()

      let totalResponse = await WorkOrderClient.List(
        query
          .Paginate(pagination.skip, pagination.take)
          .WithParam('ShowAllWorkOrdersForChildView', true)
          .WithParentWorkOrderId(params.id)
          .Sort(pagination.sort, pagination.direction)
          .Paginate(0, 1)
      )

      setCwoCount(totalResponse.data.total)

      // Fetch child work orders for dropdown (when viewing parent OR child)
      const parentWorkOrderId = data.isParent ? params.id : data.parentWorkOrder?.id

      if (parentWorkOrderId) {
        setLoadingChildWorkOrders(true)
        try {
          let childQuery = new WorkOrderQueryParams()
          let childResponse = await WorkOrderClient.List(
            childQuery
              .WithParam('ShowAllWorkOrdersForChildView', true)
              .WithParentWorkOrderId(parentWorkOrderId)
              .Sort('name', 'asc')
              .Paginate(0, 10000)
          )

          if (childResponse.authenticated && childResponse.data) {
            const children = childResponse.data.data || []
            setChildWorkOrders(children)

            // If viewing a child work order, set it as selected
            if (!data.isParent && data.id) {
              const currentChild = children.find((child: any) => child.id === data.id)
              if (currentChild) {
                setSelectedChildWorkOrder({
                  value: currentChild.id,
                  label: `${currentChild.workOrderNumber || 'N/A'} - ${
                    currentChild.workOrderCategory?.name || 'N/A'
                  } - ${currentChild.workOrderStatus?.name || 'N/A'}`,
                })
              }
            } else {
              // Clear selection when viewing parent
              setSelectedChildWorkOrder(null)
            }
          }
        } catch (e) {
          console.error(e)
        } finally {
          setLoadingChildWorkOrders(false)
        }
      } else {
        // No parent work order, clear children and selection
        setChildWorkOrders([])
        setSelectedChildWorkOrder(null)
      }

      // Fetch due date audit history
      await fetchDueDateAudits(data.id)
      await fetchExpectedOnSiteAudits(data.id)
    }
    setLoading(false)
  }

  const checkSupplierStatus = async (data: any) => {
    console.log(data.assignedToTenant)

    if (data.assignedToTenant) {
      setSupplierStatusLoading(true)
      if (!data.assignedToTenant.externalId || data.assignedToTenant.externalId.length === 0) {
        setSupplierStatus({isAvailableForUse: false, message: 'No MYOB Supplier ID specified'})
      } else {
        let supplierResponse = await WorkOrderClient.CheckSupplierStatusInMyob(
          data.assignedToTenant.externalId
        )
        if (supplierResponse.successful) {
          setSupplierStatus(supplierResponse.data)
        } else {
          setSupplierStatus({isAvailableForUse: false, message: 'Error checking MYOB Supplier ID'})
        }
      }
      setSupplierStatusLoading(false)
    }
  }

  const fetchWorkOrderStatusData = async () => {
    let query = new WorkOrderStatusQueryParams()
    let response = await WorkOrderStatusClient.List(
      query
        .Paginate(pagination.skip, pagination.take)
        .Search('')
        .WithActive(true)
        .Sort(pagination.sort, pagination.direction)
    )

    if (!response.authenticated) {
    } else {
      const {data} = response
      setWorkOrderStatus(data?.data)
    }
  }

  const getCategoryWorkScope = async (categoryId: any, workScopeId: any) => {
    if (categoryId && workScopeId) {
      let query = new CategoryWorkScopesQueryParams()
      let response = await CategoryWorkScopesClient.List(
        query
          .Paginate(0, 1)
          .WithActive(true)
          .Sort('id', 'desc')
          .WithWorkOrderCategoryId(categoryId)
          .WithWorkScopeId(workScopeId)
      )

      if (response.successful) {
        const {data} = response.data
        if (data.length > 0) setCategoryWorkScope(data[0])
      }
    }
  }

  const UpdateStatus = async (newWorkOrderStatusId: string) => {
    let selected = WorkOrderStatus.find((c) => c.id === newWorkOrderStatusId)

    setSelectedWorkOrderStatusId(newWorkOrderStatusId)

    setWorkOrder({
      ...workOrder,
      workOrderStatusId: newWorkOrderStatusId,
      workOrderStatus: {name: selected.name},
    })
  }

  const SyncWorkOrderToMYOB = async () => {
    setLoading(true)

    let wo = {...workOrder}
    const {id} = wo

    let response = await WorkOrderClient.ForceSync(id)

    if (!response.successful) {
      //show error
    } else {
      await fetchData()
      setLoading(false)
    }
  }

  const UpdateWorkOrderStatus = async () => {
    setLoading(true)

    let selected = WorkOrderStatus.find((c) => c.id === selectedWorkOrderStatusId)

    try {
      await WorkOrderClient.SetStatus(workOrder.id, selectedWorkOrderStatusId)
      toast.success(selected?.description || 'Status updated successfully')
    } catch (e: any) {
      toast.error(
        e?.response?.data?.errorMessage ||
          e?.response?.data?.message ||
          'Unable to update status. Please check the current status and try again.'
      )
    }

   
    try {
      await fetchData()
    } catch (e) {
      console.error(e)
    }

    setRefreshQuotesList((v) => !v)
    setLoading(false)
    setOnChangeFlag(false)
  }

  const UpdateExpectedOnSite = async (newExpectedOnSite: string, reason: string) => {
    setLoading(true)
    await WorkOrderClient.UpdateExpectedOnSite(
      workOrder.id,
      new Date(newExpectedOnSite).toISOString(),
      reason
    )
    await fetchData()
    await fetchExpectedOnSiteAudits()
  }

  const updateLocalOnly = async (localOnly: boolean) => {
    setLoading(true)

    await WorkOrderClient.UpdateField(workOrder.id, 'localOnly', localOnly)
    await fetchData()
  }

  const updateDueDate = async (newDueOnSite: string, reason?: string) => {
    setLoading(true)
    await WorkOrderClient.UpdateDueDate(workOrder.id, new Date(newDueOnSite).toISOString(), reason)
    await fetchData()
    await fetchDueDateAudits()
  }

  const fetchDueDateAudits = async (workOrderId?: string) => {
    const id = workOrderId || workOrder.id
    if (!id) return

    try {
      const response = await WorkOrderClient.GetDueDateAudit(id, 0, 1)
      if (response.successful && response.data) {
        // Store total count for badge display
        setDueDateAudits(Array(response.data.total || 0).fill(null))
      }
    } catch (error) {
      console.error('Error fetching due date audits:', error)
    }
  }

  const fetchExpectedOnSiteAudits = async (workOrderId?: string) => {
    const id = workOrderId || workOrder.id
    if (!id) return

    try {
      const response = await WorkOrderClient.GetExpectedOnSiteAudit(id, 0, 1)
      if (response.successful && response.data) {
        // Store total count for badge display
        setExpectedOnSiteAudits(Array(response.data.total || 0).fill(null))
      }
    } catch (error) {
      console.error('Error fetching expected on site audits:', error)
    }
  }

  const updateCost = async (newCost: any) => {
    setCostLoading(true)

    const tenantRequest = await TenantsClient.Get(workOrder?.tenantId)
    const tenant = tenantRequest.data

    let priorityQuery = await ClientPrioritySettingsClient.List(
      new ClientPrioritySettingsQueryParams()
        .Paginate(0, 10)
        .WithClientId(tenant.id)
        .WithPriorityId(workOrder.priorityId)
        .Sort('id', 'asc')
    )

    let priority = priorityQuery?.data?.data[0] ?? null

    let priorityFee = priority ? priority.fee : 0

    let percentageFee = tenant.percentageFee != null ? tenant.percentageFee / 100 : 0

    let estimate = parseFloat(newCost)

    let percentageFeeAmount = percentageFee > 0 ? estimate * percentageFee : 0

    let baseCost = (estimate ?? 0) + percentageFeeAmount + priorityFee
    let adminFee = tenant.adminFee ?? 0

    let tenantThreshold = tenant.thresholdMoney ?? 0

    if (baseCost > tenantThreshold - adminFee) {
      setCostError('The entered cost requires a quote')
    } else {
      let response = await WorkOrderClient.UpdateField(workOrder.id, 'costEstimate', newCost)

      if (!response.successful) {
        setCostError(response.data.errorMessage)
        return false
      } else {
        await fetchData()
        return true
      }
    }
  }

  const renderItems = () => {
    switch (selectedTab) {
      case NavItems.Notes:
        if (hideChildCostAndNotes) return null
        return <NotesList workOrderId={params.id} refreshWO={fetchData} />

      case NavItems.Quotes:
        if (workOrder.isParent) {
          const ParentQuotesComponent = enableQuoteSummary
            ? QuotesForParentWorkOrderList
            : QuotesForParentWorkOrderListLegacy
          return (
            <ParentQuotesComponent
              workOrderId={params.id}
              refreshWO={fetchData}
              refreshList={refreshQuotesList}
              refreshData={() => {
                setRefreshQuotesList(!refreshQuotesList)
              }}
              workOrderNumber={workOrder.workOrderNumberId}
            />
          )
        } else {
          const QuotesComponent = enableQuoteSummary ? QuotesList : QuotesListLegacy
          return (
            <QuotesComponent
              workOrderId={params.id}
              workOrder={workOrder}
              refreshWO={fetchData}
              refreshList={refreshQuotesList}
              isParentWorkOrder={workOrder.isParent}
            />
          )
        }

      case NavItems.Attachments:
        return <AttachmentsList workOrderId={params.id} refreshParentList={fetchData} />

      case NavItems.Assignments:
        return <p>Assignments</p>

      case NavItems.Reviews:
        return <ReviewsList workOrderId={params.id} refreshWO={fetchData} />

      case NavItems.Participants:
        return <ParticipantsList workOrder={workOrder} refreshWO={fetchData} />

      case NavItems.CheckIns:
        return (
          <CheckInsList
            workOrder={workOrder}
            siteId={workOrder.siteId}
            workOrderId={params.id}
            refreshWorkOrder={() => fetchData()}
            getAll
          />
        )

      case NavItems.Notices:
        return <NoticeSitesList siteId={workOrder.siteId} workOrderId={workOrder.id} />

      case NavItems.Charges:
        return (
          <ChargesList
            workOrderId={params.id}
            refreshWorkOrder={() => {
              void fetchData()
              setRefreshQuotesList((v) => !v)
            }}
            refreshList={refreshQuotesList}
            enableQuoteSummary={enableQuoteSummary}
          />
        )

      case NavItems.WorkOrderHistoryList:
        return <WorkOrderHistoryList workOrderId={params.id} />

      case NavItems.CheckLists:
        return (
          <SiteCheckList
            siteId={workOrder.siteId}
            workOrderId={params.id}
            refreshWorkOrder={() => fetchData()}
          />
        )
      case NavItems.Children:
        return <WorkOrderChildren parentWorkOrderId={params.id} />

      case NavItems.Assets:
        return <WorkOrderAssetsList workOrderId={params.id} siteId={workOrder?.siteId} />
    }
  }

  const defaultDueDate = moment().add(1, 'hour').format('YYYY-MM-DDTHH:mm:00')
  const defaultExpectedOnSite = moment().add(1, 'hour').format('YYYY-MM-DDTHH:mm:00')
  const [showDueOnSite, setShowDueOnSite] = useState(false)

  const [dueOnSite, setDueOnSite] = useState(defaultDueDate)
  const [dueOnSiteLoading, setDueOnSiteLoading] = useState(false)
  const [dueOnSiteSuccess, setDueOnSiteSuccess] = useState(false)

  const [showDueDate, setShowDueDate] = useState(false)
  const [showDueDateAuditModal, setShowDueDateAuditModal] = useState(false)

  const [dueDateAudits, setDueDateAudits] = useState<any[]>([])

  const [showExpectedOnSite, setShowExpectedOnSite] = useState(false)
  const [showExpectedOnSiteAuditModal, setShowExpectedOnSiteAuditModal] = useState(false)

  const [expectedOnSiteAudits, setExpectedOnSiteAudits] = useState<any[]>([])

  const [showCost, setShowCost] = useState(false)
  const [cost, setCost] = useState(0)
  const [costLoading, setCostLoading] = useState(false)
  const [costError, setCostError] = useState<any>(null)
  const [costSuccess, setCostSuccess] = useState(false)
  const [syncToMYOB, setSyncToMYOB] = useState(false)
  const [showMessageModal, setShowMessageModal] = useState(false)
  const [showBulkUploadModel, setShowBulkUploadModel] = useState(false)
  const [showWorkFlowModal, setShowWorkFlowModal] = useState(false)
  const [showReviewModal, setShowReviewModal] = useState(false)
  const [showMessageListModal, setShowMessageListModal] = useState(false)
  const [showQuoteModal, setShowQuoteModal] = useState(false)

  const renderModals = () => (
    <>
      <QuotesModal
        mode={'Add'}
        workOrderId={params.id}
        isClient={
          user.tenant.tenantTypeId.toUpperCase() === TenantTypeIds.Client ||
          user.tenant.tenantTypeId.toUpperCase() === TenantTypeIds.Owner
        }
        handleOk={() => {
          setRefreshQuotesList(!refreshQuotesList)
          fetchData().then(() => {})
          setShowQuoteModal(false)
        }}
        handleClose={() => {
          setShowQuoteModal(false)
        }}
        thresholdMoney={workOrder?.tenant?.thresholdMoney ?? 0}
        selectedData={undefined}
        defaultAmount={cost}
        show={showQuoteModal}
      />
      <BulkUploadModal
        handleOk={() => {
          setShowBulkUploadModel(false)
          fetchData().then(() => {})
        }}
        handleClose={() => {
          setShowBulkUploadModel(false)
        }}
        show={showBulkUploadModel}
        workOrder={workOrder}
      />
      <WorkOrderMessageModal
        handleOk={() => {
          setShowMessageModal(false)
        }}
        handleClose={() => {
          setShowMessageModal(false)
        }}
        show={showMessageModal}
        workOrder={workOrder}
      />
      <SweetAlertWithProp
        show={showWorkFlowModal}
        title='Work Flow'
        onCancel={() => {
          setShowWorkFlowModal(false)
        }}
        showCancel={false}
        showConfirm={false}
        cancelBtnText='Close'
        style={{width: '1000px'}}
        allowEscape
      >
        <WorkOrderHistoryList workOrderId={params.id} />
      </SweetAlertWithProp>

      <SweetAlertWithProp
        show={showReviewModal}
        title='Reviews'
        onCancel={() => {
          setShowReviewModal(false)
        }}
        showCancel={false}
        showConfirm={false}
        cancelBtnText='Close'
        style={{width: '1000px'}}
        allowEscape
      >
        <ReviewsList workOrderId={params.id} refreshWO={fetchData} />
      </SweetAlertWithProp>

      <SweetAlertWithProp
        show={showMessageListModal}
        title='Messages'
        onCancel={() => {
          setShowMessageListModal(false)
        }}
        showCancel={false}
        showConfirm={false}
        cancelBtnText='Close'
        style={{width: '1000px'}}
        allowEscape
      >
        <MessagesList workOrderId={params.id} />
      </SweetAlertWithProp>

      <SweetAlertWithProp
        show={syncToMYOB}
        title='Sync Information'
        onConfirm={() => {
          setSyncToMYOB(false)
          SyncWorkOrderToMYOB().then(() => {})
        }}
        showCancel={false}
      >
        <p>
          Cost will only be updated in MYOB if the PO is on hold. If you want to update the cost in
          MYOB, please put the PO on hold first or re-sync later once the PO is on hold.
        </p>
      </SweetAlertWithProp>

      <SweetAlertWithProp
        id='assignToProjectModal'
        customClass={'assignToProject'}
        show={showAssignToProjectModal}
        title='Assign WO to Project'
        onCancel={() => setShowAssignToProjectModal(false)}
        showCancel={true}
        showConfirm={false}
      >
        <p style={{zIndex: '2'}}>
          <div style={{zIndex: '2'}}>
            <AsyncSelect
              loadOptions={loadOptions}
              formatOptionLabel={formatOptionLabel}
              onChange={async (e) => {
                setShowAssignToProjectModal(false)
                await WorkOrderClient.AssignToProject(workOrder.id, e.value)
                await fetchData()
              }}
            />
          </div>
        </p>
      </SweetAlertWithProp>

      <AssignToModal workOrder={workOrder} handleOk={() => fetchData()} />
      <SweetAlertWithProp
        show={dueOnSiteSuccess}
        success
        title='Success'
        onConfirm={() => setDueOnSiteSuccess(false)}
        showCancel={false}
      >
        Date on Site has been set!
      </SweetAlertWithProp>
      <SweetAlertWithProp
        title={'Set Date on Site'}
        onConfirm={() => {}}
        onCancel={() => {}}
        type={'controlled'}
        dependencies={[showDueOnSite]}
        show={showDueOnSite}
        required
        showCancel
        closeOnClickOutside={false}
        customButtons={
          <React.Fragment>
            <button
              onClick={() => {
                setDueOnSite(defaultDueDate)
                setShowDueOnSite(false)
              }}
              className='btn btn-lg btn-light'
            >
              Cancel
            </button>
            <span style={{paddingRight: '5px'}}></span>
            {dueOnSite && (
              <button
                onClick={async () => {
                  setDueOnSiteLoading(true)
                  await UpdateExpectedOnSite(dueOnSite, '')

                  setDueOnSiteLoading(false)
                  setDueOnSite(defaultDueDate)
                  setShowDueOnSite(false)
                  setDueOnSiteSuccess(true)
                }}
                className='btn btn-lg btn-primary'
                disabled={dueOnSiteLoading}
              >
                Confirm
                <span style={{paddingRight: '3px'}}></span>
                {dueOnSiteLoading && (
                  <Spinner
                    as='span'
                    animation='border'
                    size='sm'
                    role='status'
                    aria-hidden='true'
                  />
                )}
              </button>
            )}
          </React.Fragment>
        }
      >
        {() => (
          <form>
            <input
              type='datetime-local'
              name='expectedOnSite'
              placeholder=''
              className='form-control form-control-solid'
              id='expectedOnSite'
              value={dueOnSite}
              defaultValue={dueOnSite}
              onChange={(e) => {
                let value = e.target.value
                setDueOnSite(value)
              }}
            />
          </form>
        )}
      </SweetAlertWithProp>
      <DueDateModal
        show={showDueDate}
        handleClose={() => setShowDueDate(false)}
        handleOk={() => {}}
        workOrder={workOrder}
        defaultDueDate={defaultDueDate}
        onUpdateDueDate={async (newDueDate: string, reason: string) => {
          await updateDueDate(newDueDate, reason)
        }}
      />

      <DueDateAuditModal
        show={showDueDateAuditModal}
        handleClose={() => setShowDueDateAuditModal(false)}
        workOrderId={workOrder.id}
      />

      <ExpectedOnSiteModal
        show={showExpectedOnSite}
        handleClose={() => setShowExpectedOnSite(false)}
        handleOk={() => setShowExpectedOnSite(false)}
        workOrder={workOrder}
        defaultExpectedOnSite={defaultExpectedOnSite}
        onUpdateExpectedOnSite={async (newExpectedOnSite: string, reason: string) => {
          await UpdateExpectedOnSite(newExpectedOnSite, reason)
        }}
      />

      <ExpectedOnSiteAuditModal
        show={showExpectedOnSiteAuditModal}
        handleClose={() => setShowExpectedOnSiteAuditModal(false)}
        workOrderId={workOrder.id}
      />

      <SweetAlertWithProp
        show={costSuccess}
        success
        title='Success'
        onConfirm={() => {
          setCostSuccess(false)
          setCostLoading(false)
        }}
        showCancel={false}
      >
        Cost Estimate has been set!
      </SweetAlertWithProp>
      <SweetAlertWithProp
        title={'Set Cost Estimate'}
        onConfirm={() => {}}
        onCancel={() => {}}
        type={'controlled'}
        dependencies={[showCost]}
        show={showCost}
        required
        showCancel
        closeOnClickOutside={false}
        customButtons={
          <React.Fragment>
            <button
              onClick={() => {
                setCostError(null)
                setShowCost(false)
              }}
              className='btn btn-lg btn-light'
            >
              Cancel
            </button>
            <span style={{paddingRight: '5px'}}></span>
            {cost > 0 && !costError && (
              <button
                onClick={async () => {
                  setCostError(null)
                  setCostLoading(true)
                  const res = await updateCost(cost)

                  setCostLoading(false)
                  if (res) {
                    setShowCost(false)
                    setCostSuccess(true)
                  } else {
                  }
                }}
                className='btn btn-lg btn-primary'
                disabled={costLoading}
              >
                Confirm
                <span style={{paddingRight: '3px'}}></span>
                {costLoading && (
                  <Spinner
                    as='span'
                    animation='border'
                    size='sm'
                    role='status'
                    aria-hidden='true'
                  />
                )}
              </button>
            )}

            {cost > 0 && costError && (
              <button
                onClick={async () => {
                  setShowCost(false)
                  setShowQuoteModal(true)
                }}
                className='btn btn-lg btn-primary'
                disabled={costLoading}
              >
                Confirm
                <span style={{paddingRight: '3px'}}></span>
                {costLoading && (
                  <Spinner
                    as='span'
                    animation='border'
                    size='sm'
                    role='status'
                    aria-hidden='true'
                  />
                )}
              </button>
            )}
          </React.Fragment>
        }
      >
        {() => (
          <form>
            {user.tenant?.tenantTypeId?.toUpperCase() === TenantTypeIds.Owner &&
              workOrder?.dataProvider !== 'none' && (
                <p>
                  Cost will only be updated in MYOB if the PO is on hold. If you want to update the
                  cost in MYOB, please put the PO on hold first or re-sync later once the PO is on
                  hold.
                </p>
              )}

            <input
              type='number'
              defaultValue={cost}
              value={cost}
              onChange={(e: any) => {
                let value = e.target.value
                value =
                  value.indexOf('.') >= 0
                    ? value.slice(0, value.indexOf('.')) +
                      value.slice(value.indexOf('.'), value.indexOf('.') + 3)
                    : value

                setCost(value)
              }}
              className='form-control form-control-solid'
              name='costEstimate'
              data-kt-element='price'
              disabled={costLoading}
            />
            {costError && <p className='text-danger text-center'>{costError}</p>}
          </form>
        )}
      </SweetAlertWithProp>
      {workOrder?.isParent && enableQuoteSummary && (
        <WorkOrderProjectCostModal
          handleClose={() => {
            setShowProjectCostModal(false)
          }}
          show={showProjectCostModal}
          parentWorkOrderId={workOrder?.id}
          parentWorkOrderDisplay={formatWorkOrderDisplay(workOrder)}
          updateParentProjectCost={(sum) => {
            if (workOrder?.isParent) setProjectCost(sum)
          }}
          refreshData={refreshQuotesList}
        />
      )}
      {workOrder?.isParent && !enableQuoteSummary && (
        <WorkOrderProjectCostModalLegacy
          handleClose={() => {
            setShowProjectCostModal(false)
          }}
          show={showProjectCostModal}
          parentWorkOrderId={workOrder?.id}
          updateParentProjectCost={(sum) => {
            if (workOrder?.isParent) setProjectCost(sum)
          }}
          refreshData={refreshQuotesList}
        />
      )}
    </>
  )

  const userPopover = () => {
    return (
      <Popover id='userPopover' style={{maxWidth: '900px'}}>
        <Popover.Content>
          <table>
            <tbody>
              <tr>
                <td style={{paddingRight: '20px'}}>
                  <div className='fs-6'>
                    <div className='fw-bolder mt-1'>Mobile</div>
                    <div className='text-gray-600'>{workOrder.createdBy?.mobile}</div>
                  </div>
                </td>
                <td>
                  <div className='fs-6'>
                    <div className='fw-bolder mt-1'>Email</div>
                    <div className='text-gray-600'>{workOrder.createdBy?.email}</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </Popover.Content>
      </Popover>
    )
  }

  const sideMenuPopOver = () => {
    return (
      <Popover
        id='sideMenuPopOver'
        style={{minWidth: '150px', left: '-120px', top: '-10px'}}
        onClick={() => document.body.click()} //to close the popover when clicking inside
      >
        <Popover.Content style={{padding: 0}}>
          <table style={{borderCollapse: 'separate', borderSpacing: '20px'}}>
            <tbody>
              <tr>
                <td
                  style={{cursor: 'pointer'}}
                  onClick={() => {
                    setShowWorkFlowModal(true)
                  }}
                >
                  <div className='nav-item fs-5 fw-bolder' style={{cursor: 'pointer'}}>
                    Work Flow
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{cursor: 'pointer'}}
                  onClick={() => {
                    setShowReviewModal(true)
                  }}
                >
                  <div className='nav-item fs-5 fw-bolder' style={{cursor: 'pointer'}}>
                    Reviews
                  </div>
                </td>
              </tr>
              {permissions.includes(Permissions.MANAGE_WORKORDER_MESSAGE) && (
                <tr>
                  <td
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                      setShowMessageListModal(true)
                    }}
                  >
                    <div className='nav-item fs-5 fw-bolder' style={{cursor: 'pointer'}}>
                      Messages
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Popover.Content>
      </Popover>
    )
  }

  // Compute dropdown options from childWorkOrders
  const childWorkOrderOptions = useMemo(() => {
    if (!childWorkOrders || childWorkOrders.length === 0) {
      return []
    }
    return childWorkOrders.map((item: any) => ({
      value: item.id,
      label: `${item.workOrderNumber || 'N/A'} - ${item.workOrderCategory?.name || 'N/A'} - ${
        item.workOrderStatus?.name || 'N/A'
      }`,
    }))
  }, [childWorkOrders])

  // Handle dropdown selection and navigate
  const handleChildWorkOrderChange = (selectedOption: any) => {
    if (selectedOption) {
      setSelectedChildWorkOrder(selectedOption)
      history.push(`/work-orders/details/${selectedOption.value}`)
    }
  }

  // Custom dropdown indicator component with loading spinner
  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        {loadingChildWorkOrders ? (
          <span
            className='spinner-border spinner-border-sm'
            role='status'
            aria-hidden='true'
            style={{width: '12px', height: '12px', borderWidth: '2px'}}
          ></span>
        ) : (
          props.children
        )}
      </components.DropdownIndicator>
    )
  }

  // Custom styles for Select dropdown
  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      background: '#f5f8fa',
      borderRadius: '5px',
      minWidth: '300px',
    }),
    indicatorSeparator: (_: any) => ({
      display: 'none',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      padding: '8px',
    }),
    menuPortal: (base: any) => ({...base, zIndex: 5601}),
    singleValue: (provided: any) => ({...provided, background: '#f5f8fa'}),
    placeholder: (defaultStyles: any) => ({...defaultStyles, background: '#f5f8fa'}),
  }

  // Helper function to download file
  const downloadFile = async (blobResponse: any, filename: string) => {
    const blob = await blobResponse
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.style.display = 'none'
    const url = window.URL.createObjectURL(blob.data)
    a.href = url
    a.download = filename
    a.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }

  // Render child work order dropdown
  const renderChildWorkOrderDropdown = () => {
    if (!childWorkOrderOptions.length && !loadingChildWorkOrders) return null

    return (
      <div style={{minWidth: '300px', marginLeft: '15px'}}>
        <Select
          id='child-work-order-select'
          name='childWorkOrder'
          onChange={handleChildWorkOrderChange}
          value={selectedChildWorkOrder}
          options={childWorkOrderOptions}
          placeholder='Select work order'
          isDisabled={loading || loadingChildWorkOrders}
          styles={customStyles}
          components={{DropdownIndicator}}
          menuPortalTarget={document.body}
        />
      </div>
    )
  }

  // Render submitted quotes section (only for parent work orders)
  const renderSubmittedQuotes = () => {
    if (
      !workOrder?.childrenThatHasSubmittedQuote ||
      workOrder.childrenThatHasSubmittedQuote.length === 0 ||
      user.tenant?.tenantTypeId?.toUpperCase() !== TenantTypeIds.Owner
    ) {
      return null
    }

    return (
      <div style={{paddingLeft: '5px', color: 'red'}}>
        Submitted Quotes:
        {workOrder.childrenThatHasSubmittedQuote.map((wo: any) => (
          <Link
            key={wo.id}
            to={`/work-orders/details/` + wo.id}
            style={{marginLeft: '5px', color: 'red'}}
          >
            {`${wo?.workOrderNumber}`}
          </Link>
        ))}
      </div>
    )
  }

  // Render parent work order action buttons
  const renderParentWorkOrderActions = () => {
    if (!workOrder.isParent) return null

    return (
      <div>
        <button
          className='btn btn-sm btn-light-primary me-3'
          style={{cursor: 'pointer'}}
          onClick={() =>
            downloadFile(
              WorkOrderClient.DownloadBulkUploadCsv(workOrder.id),
              `template_bulk_upload_workorder_${workOrder.workOrderNumber}.csv`
            )
          }
        >
          Bulk upload template{' '}
          <KTSVG
            path='/media/icons/duotune/arrows/arr004.svg'
            className='svg-icon-3 svg-icon-dark'
          />
        </button>

        <button
          className='btn btn-sm btn-light-primary me-3'
          style={{cursor: 'pointer'}}
          onClick={() =>
            downloadFile(
              WorkOrderClient.DownloadSummary(workOrder.id),
              `${workOrder.workOrderNumber}-summary.csv`
            )
          }
        >
          Download summary{' '}
          <KTSVG
            path='/media/icons/duotune/arrows/arr004.svg'
            className='svg-icon-3 svg-icon-dark'
          />
        </button>

        <button
          className='btn btn-sm btn-primary me-5'
          onClick={() => setShowBulkUploadModel(true)}
        >
          <span className='ml-1'>Bulk upload</span>
        </button>

        <ReadyIndicator
          isReady={workOrder.isReady}
          statusFlowId={workOrder.statusFlowId}
          mode='parent'
        />
      </div>
    )
  }

  // Check if project work order section should be shown
  const shouldShowProjectWorkOrderSection =
    !loading &&
    (workOrder.isParent || workOrder.workOrderId) &&
    user.tenant?.tenantTypeId?.toUpperCase() !== TenantTypeIds.Contractor

  const isClient = user.tenant?.tenantTypeId?.toUpperCase() === TenantTypeIds.Client
  const isChildWorkOrder = !!workOrder.workOrderId
  const hideChildCostAndNotes = isClient && isChildWorkOrder

  return (
    <>
      {renderModals()}

      <div className='post d-flex flex-column-fluid' id='kt_post'>
        <div id='kt_content_container' className='container' style={{padding: '0'}}>
          {shouldShowProjectWorkOrderSection && (
            <div className='card mb-2'>
              <div
                className='card-body d-flex justify-content-between'
                style={{padding: '1.5rem 2rem'}}
              >
                <div className='d-flex align-items-center'>
                  <div className='d-flex align-items-center'>
                    <KTSVG
                      path='/media/icons/duotune/abstract/abs026.svg'
                      className='svg-icon-dark svg-icon-1'
                    />
                    {workOrder.isParent ? (
                      <>
                        <b style={{paddingLeft: '5px'}}>Project Work Order</b>
                        {renderSubmittedQuotes()}
                      </>
                    ) : (
                      <>
                        <b style={{paddingLeft: '5px'}}>Project Work Order : </b>{' '}
                        <Link
                          style={{paddingLeft: '5px'}}
                          to={`/work-orders/details/` + workOrder?.parentWorkOrder?.id}
                        >
                          {`${workOrder?.parentWorkOrder?.workOrderNumber}`}
                        </Link>
                      </>
                    )}
                  </div>
                  {renderChildWorkOrderDropdown()}
                </div>

                <div className='d-flex align-items-center'>
                  {workOrder.isBulkUpload && (
                    <span className='badge badge-info me-3' style={{marginTop: '5px'}}>
                      Bulk upload
                    </span>
                  )}
                  {renderParentWorkOrderActions()}
                  {!workOrder.isParent && (
                    <ReadyIndicator
                      isReady={workOrder.isReady}
                      statusFlowId={workOrder.statusFlowId}
                      mode='child'
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          <div className='card mb-5 mb-xxl-8'>
            <div className='card-body pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap'>
                <div className='me-5 mb-4' style={{minWidth: '12%'}}>
                  <div className='d-flex flex-center flex-column py-5'>
                    <div className='symbol symbol-150px'>
                      {imageLogo && (
                        <img
                          alt='logo'
                          className='h-75 align-self-end pb-2'
                          src={imageLogo}
                          onError={() => {
                            setImageLogo('')
                          }}
                        ></img>
                      )}
                    </div>
                    {(user.id === workOrder?.createdById ||
                      user.tenantId === workOrder?.createdBy?.tenantId ||
                      user.tenantId === workOrder?.tenantId ||
                      user.tenant?.tenantTypeId?.toUpperCase() === TenantTypeIds.Owner) && (
                      <Link
                        className='btn btn-sm btn-light-primary'
                        to={`/work-orders/edit/${params.id}`}
                      >
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr075.svg'
                          className='svg-icon-3'
                        />
                        Edit
                      </Link>
                    )}

                    {workOrder.department && (
                      <div className='fs-6'>
                        <div className='fw-bolder mt-5'>Department</div>
                        <div className='text-gray-600'>{workOrder?.department?.name}</div>
                      </div>
                    )}
                    {workOrder.ocManaged && (
                      <span className='badge badge-info' style={{marginTop: '5px'}}>
                        OC Managed
                      </span>
                    )}
                    <div className='fs-6'>
                      <div className='fw-bolder mt-5'>Client</div>
                      <div className='text-gray-600'>{workOrder.tenant?.name}</div>
                      <div>
                        <div className='fw-bolder mt-1'>Site Address</div>
                        <div className='text-gray-600'>
                          {workOrder.site?.address1}, {workOrder.site?.city},{' '}
                          {workOrder.site?.country}
                        </div>
                      </div>
                      {permissions.includes(Permissions.MANAGE_WORKORDER_MESSAGE) && (
                        <div className='mt-2'>
                          <button
                            className='btn btn-sm btn-light-primary'
                            onClick={() => {
                              setShowMessageModal(true)
                            }}
                          >
                            <KTSVG
                              path='/media/icons/duotune/communication/com010.svg'
                              className='svg-icon-3'
                            />
                            <span className='ml-1'>Message</span>
                          </button>
                        </div>
                      )}
                    </div>

                    {/* <button
                      type='button'
                      className='btn btn-sm btn-primary me-5 mt-2'
                      disabled={loading}
                      onClick={async () => {
                        setLoading(true)
                        await WorkOrderClient.RemoveFromProject(workOrder.id)
                        await fetchData()
                      }}
                    >
                      Remove from project
                    </button> */}
                  </div>
                </div>

                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap'>
                    <div className='d-flex'>
                      {!loading && (
                        <span className='text-gray-900 fw-bolder'>
                          <span style={{paddingRight: '5px', fontSize: '2rem'}}>
                            {`${workOrder.workOrderNumber}`}
                          </span>

                          {workOrder.assignedToTenant && (
                            <>
                              <span style={{paddingRight: '10px', fontSize: '1.5rem'}}>
                                {`: ${workOrder.assignedToTenant?.name}`}{' '}
                                {workOrder.workOrderStatus?.name?.toLowerCase() !== 'cancelled' &&
                                  workOrder.workOrderStatus?.name?.toLowerCase() !== 'complete' &&
                                  workOrder.workOrderStatus?.name?.toLowerCase() !== 'pending' &&
                                  !workOrder.hasActiveCheckIns &&
                                  user.tenant?.tenantTypeId?.toUpperCase() ===
                                    TenantTypeIds.Owner && (
                                    <span
                                      style={{cursor: 'pointer'}}
                                      data-bs-toggle='modal'
                                      data-bs-target='#wo_assign_to_modal'
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/general/gen055.svg'
                                        className='svg-icon-3'
                                      />
                                    </span>
                                  )}
                              </span>

                              {supplierStatusLoading && (
                                <span className='me-2'>
                                  <Spinner
                                    as='span'
                                    animation='border'
                                    size='sm'
                                    role='status'
                                    aria-hidden='true'
                                  />
                                </span>
                              )}

                              {!supplierStatusLoading && supplierStatus.isAvailableForUse && (
                                <OverlayTrigger
                                  placement='bottom'
                                  overlay={
                                    <Tooltip id='supplier-good'>
                                      Supplier set up correctly & active
                                    </Tooltip>
                                  }
                                >
                                  <i
                                    className='bi bi-check2-circle me-2'
                                    style={{color: 'green'}}
                                  ></i>
                                </OverlayTrigger>
                              )}

                              {!supplierStatusLoading && !supplierStatus.isAvailableForUse && (
                                <OverlayTrigger
                                  placement='bottom'
                                  overlay={
                                    <Tooltip id='supplier-bad'>{supplierStatus.message}</Tooltip>
                                  }
                                >
                                  <i
                                    className='bi bi-slash-circle-fill me-2'
                                    style={{color: 'red'}}
                                  ></i>
                                </OverlayTrigger>
                              )}

                              {!workOrder.isParent &&
                                workOrder.assignedToTenantId &&
                                !workOrder.costEstimate &&
                                user.tenant?.tenantTypeId?.toUpperCase() !==
                                  TenantTypeIds.Client &&
                                (enableQuoteSummary ? (
                                  <div className='d-flex align-items-center'>
                                    <Link
                                      className={`btn btn-sm btn-primary me-2 ms-2${
                                        loading ? ' disabled' : ''
                                      }`}
                                      to={`/quotes/new/${workOrder.id}`}
                                      onClick={(e) => {
                                        if (loading) e.preventDefault()
                                      }}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/arrows/arr075.svg'
                                        className='svg-icon-3'
                                      />
                                      Add Quote
                                    </Link>
                                  </div>
                                ) : (
                                  <button
                                    type='button'
                                    className='btn btn-sm btn-primary me-5 ms-2'
                                    disabled={loading}
                                    onClick={() => {
                                      if (workOrder.workOrderId || workOrder.isParent) {
                                        setShowQuoteModal(true)
                                      } else if (
                                        workOrder.workScope?.name?.toLowerCase() === 'minor'
                                      ) {
                                        setCostError(null)
                                        setCost(0)
                                        setShowCost(true)
                                        if (workOrder.costEstimate)
                                          setCost(workOrder.costEstimate)
                                      } else if (
                                        workOrder.workScope?.name?.toLowerCase() === 'major'
                                      ) {
                                        setShowQuoteModal(true)
                                      }
                                    }}
                                  >
                                    Add Cost
                                  </button>
                                ))}
                            </>
                          )}

                          {workOrder.hasActiveCheckIns && (
                            <span
                              className='badge badge-success'
                              style={{
                                verticalAlign: 'super',
                                boxShadow: '0px 0px 20px 1px darkturquoise',
                              }}
                            >
                              Active Check In
                            </span>
                          )}
                        </span>
                      )}
                      {loading && (
                        <div className='d-flex align-items-center'>
                          <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
                        </div>
                      )}
                    </div>
                    <div className='d-flex'>
                      {user.tenant?.tenantTypeId?.toUpperCase() !==
                        TenantTypeIds.OperationalClient &&
                        !workOrder.ocManaged &&
                        !workOrder.assignedToTenantId &&
                        workOrder.workOrderStatus?.name?.toLowerCase() !== 'pending' &&
                        user.tenant?.tenantTypeId?.toUpperCase() === TenantTypeIds.Owner && (
                          <button
                            type='button'
                            className='btn btn-sm btn-primary me-5'
                            data-bs-toggle='modal'
                            data-bs-target='#wo_assign_to_modal'
                            disabled={loading}
                          >
                            <KTSVG
                              path='/media/icons/duotune/ecommerce/ecm004.svg'
                              className='svg-icon-3'
                            />
                            Assign to
                          </button>
                        )}

                      {user.tenant?.tenantTypeId?.toUpperCase() ===
                        TenantTypeIds.OperationalClient &&
                        workOrder.ocManaged &&
                        !workOrder.assignedToTenantId &&
                        workOrder.workOrderStatus?.name?.toLowerCase() !== 'pending' &&
                        user.tenantId === workOrder?.tenantId && (
                          <button
                            type='button'
                            className='btn btn-sm btn-primary me-5'
                            data-bs-toggle='modal'
                            data-bs-target='#wo_assign_to_modal'
                            disabled={loading}
                          >
                            <KTSVG
                              path='/media/icons/duotune/ecommerce/ecm004.svg'
                              className='svg-icon-3'
                            />
                            Assign to
                          </button>
                        )}
                      {onChangeFlag && (
                        <button
                          onClick={() => UpdateWorkOrderStatus()}
                          type='button'
                          className='btn btn-sm btn-primary me-5'
                          disabled={loading}
                        >
                          {!loading && 'Save'}
                          {loading && (
                            <span className='indicator-progress' style={{display: 'block'}}>
                              Please wait...{' '}
                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                          )}
                        </button>
                      )}

                      {user.tenant?.tenantTypeId?.toUpperCase() === TenantTypeIds.Owner &&
                        workOrder.canBecomeProject && (
                          <button
                            type='button'
                            className='btn btn-sm btn-primary me-5'
                            disabled={loading}
                            onClick={async () => {
                              setLoading(true)
                              await WorkOrderClient.SetParent(workOrder.id)
                              await fetchData()
                            }}
                          >
                            Create project
                          </button>
                        )}

                      {user.tenant?.tenantTypeId?.toUpperCase() === TenantTypeIds.Owner &&
                        workOrder.canAssignToProject && (
                          <button
                            type='button'
                            className='btn btn-sm btn-primary me-5'
                            disabled={loading}
                            onClick={async () => {
                              setShowAssignToProjectModal(true)
                            }}
                          >
                            Assign to project
                          </button>
                        )}

                      <WorkOrderStatusUpdateSelector
                        workOrderId={workOrder.id}
                        defaultValue={{
                          value: workOrder.workOrderStatusId,
                          label: workOrder.workOrderStatus?.name,
                        }}
                        disabled={loading}
                        onChange={async (value) => {
                          setOnChangeFlag(value !== prevWorkOrderStatus?.id)
                          await UpdateStatus(value)
                        }}
                        statusFlowId={workOrder.statusFlowId}
                        excludeStatusNames={
                          user.tenant?.tenantTypeId?.toUpperCase() === TenantTypeIds.Contractor
                            ? CONTRACTOR_RESTRICTED_WORK_ORDER_STATUSES
                            : undefined
                        }
                      />

                      <IconTooltip
                        id='sideMenu-tooltip'
                        content={sideMenuPopOver()}
                        placement='left'
                        trigger='click'
                        rootClose
                        iconPath='/media/icons/duotune/general/gen053.svg'
                        iconClassName='svg-icon-1 svg-icon-gray-600'
                        containerStyle={{
                          marginLeft: '5px',
                          display: 'flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                        }}
                        containerClassName=''
                      />
                    </div>
                  </div>

                  <table>
                    <tbody>
                      <tr>
                        <td style={{paddingRight: '20px'}}>
                          <div className='fs-6'>
                            <div className='fw-bolder mt-5'>Site</div>
                            <div className='text-gray-600'>{workOrder.site?.name}</div>
                          </div>
                        </td>
                        <td style={{paddingRight: '20px'}}>
                          <div className='fs-6'>
                            <div className='fw-bolder mt-5'>Type</div>
                            <div className='text-gray-600'>{workOrder.workOrderType?.name}</div>
                          </div>
                        </td>
                        <td style={{paddingRight: '20px'}}>
                          <div className='fs-6'>
                            <div className='fw-bolder mt-5'>Category</div>
                            <div className='text-gray-600'>{workOrder.workOrderCategory?.name}</div>
                          </div>
                        </td>
                        <td style={{paddingRight: '20px'}}>
                          <div className='fs-6'>
                            <div className='fw-bolder mt-5'>Status</div>
                            <div className='text-gray-600'>
                              {onChangeFlag && prevWorkOrderStatus?.name}
                              {!onChangeFlag && workOrder?.workOrderStatus?.name}
                            </div>
                          </div>
                        </td>

                        <td style={{paddingRight: '20px'}}>
                          <div className='fs-6'>
                            <div className='fw-bolder mt-5'>
                              Work Scope
                              {categoryWorkScope && (
                                <IconTooltip
                                  id='workscope-tooltip'
                                  content={categoryWorkScope?.description}
                                />
                              )}
                            </div>
                            <div className='text-gray-600'>{workOrder.workScope?.name}</div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style={{paddingRight: '20px'}}>
                          <div className='fs-6'>
                            <div className='fw-bolder mt-5'>Date Created</div>
                            <div className='text-gray-600'>
                              {workOrder.created && (
                                <Moment utc local format='ddd DD MMM, YYYY h:mm a'>
                                  {workOrder.created}
                                </Moment>
                              )}
                            </div>
                          </div>
                        </td>

                        <td style={{paddingRight: '20px', verticalAlign: 'top'}}>
                          <div className='fs-6'>
                            <div className='fw-bolder mt-5'>
                              Due Date
                              {dueDateAudits.length > 0 && (
                                <span
                                  className='badge badge-light-primary'
                                  style={{marginLeft: '5px', cursor: 'pointer'}}
                                  onClick={() => {
                                    setShowDueDateAuditModal(true)
                                  }}
                                >
                                  {dueDateAudits.length}
                                </span>
                              )}
                              {user.tenant?.tenantTypeId?.toUpperCase() !==
                                TenantTypeIds.Contractor && (
                                <label htmlFor='expectedOnSite'>
                                  <span
                                    className='d-inline-block'
                                    style={{paddingLeft: '5px', cursor: 'pointer'}}
                                    onClick={() => {
                                      setShowDueDate(true)
                                    }}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/general/gen014.svg'
                                      className='svg-icon-3'
                                    />
                                  </span>
                                </label>
                              )}
                            </div>
                            <div className='text-gray-600'>
                              {workOrder.dueDate && (
                                <Moment utc local format='ddd DD MMM, YYYY h:mm a'>
                                  {workOrder.dueDate}
                                </Moment>
                              )}
                            </div>
                          </div>
                        </td>
                        <td style={{paddingRight: '20px', verticalAlign: 'top'}}>
                          <div className='fs-6'>
                            <div className='fw-bolder mt-5'>
                              Date on Site
                              {expectedOnSiteAudits.length > 0 && (
                                <span
                                  className='badge badge-light-primary'
                                  style={{marginLeft: '5px', cursor: 'pointer'}}
                                  onClick={() => {
                                    setShowExpectedOnSiteAuditModal(true)
                                  }}
                                >
                                  {expectedOnSiteAudits.length}
                                </span>
                              )}{' '}
                              <label htmlFor='expectedOnSite'>
                                <span
                                  className='d-inline-block'
                                  style={{paddingLeft: '5px', cursor: 'pointer'}}
                                  onClick={() => {
                                    setShowExpectedOnSite(true)
                                  }}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/general/gen014.svg'
                                    className='svg-icon-3'
                                  />
                                </span>
                              </label>
                            </div>
                            <div className='text-gray-600'>
                              {workOrder.expectedOnSite && (
                                <Moment utc local format='ddd DD MMM, YYYY h:mm a'>
                                  {workOrder.expectedOnSite}
                                </Moment>
                              )}
                            </div>
                          </div>
                        </td>

                        <td style={{paddingRight: '20px'}}>
                          <div className='fs-6'>
                            <div className='fw-bolder mt-5'>Priority</div>
                            <div className='text-gray-600'>{workOrder?.priority?.name}</div>
                          </div>
                        </td>

                        {!hideChildCostAndNotes && (
                          <td style={{paddingRight: '20px'}}>
                            <div className='fs-6'>
                              <div
                                className={`fw-bolder mt-5 ${
                                  !workOrder.isParent && enableQuoteSummary && 'cursor-pointer'
                                }`}
                              >
                                <span
                                  style={
                                    !workOrder.cost &&
                                    workOrder.workScope?.name?.toLowerCase() === 'minor'
                                      ? {color: 'red'}
                                      : {}
                                  }
                                >
                                  Cost (excl gst)
                                </span>
                              </div>
                              <div className='text-gray-600'>
                                {workOrder.cost ? toMoneyFormat(workOrder.cost) : '$'}
                              </div>
                            </div>
                          </td>
                        )}
                        <td style={{paddingRight: '20px'}}>
                          {workOrder.isParent &&
                            user.tenant?.tenantTypeId?.toUpperCase() !==
                              TenantTypeIds.Contractor && (
                              <div className='fs-6'>
                                <div className='fw-bolder mt-5'>
                                  <span>Project Cost (excl gst)</span>
                                </div>
                                <div
                                  style={
                                    workOrder.isParent &&
                                    workOrder?.childrenThatHasSubmittedQuote &&
                                    workOrder.childrenThatHasSubmittedQuote.length > 0 &&
                                    user.tenant?.tenantTypeId?.toUpperCase() === TenantTypeIds.Owner
                                      ? {color: 'red', cursor: 'pointer'}
                                      : {color: '#7e8299'}
                                  }
                                  onClick={() => {
                                    if (
                                      workOrder?.isParent &&
                                      user.tenant?.tenantTypeId?.toUpperCase() ===
                                        TenantTypeIds.Owner
                                    ) {
                                      setShowProjectCostModal(true)
                                    }
                                  }}
                                >
                                  {enableQuoteSummary
                                    ? toMoneyFormat(projectCost)
                                    : projectCost
                                      ? toMoneyFormat(projectCost)
                                      : '$'}
                                </div>
                              </div>
                            )}
                        </td>
                      </tr>

                      <tr>
                        {user.tenant?.tenantTypeId?.toUpperCase() !== TenantTypeIds.Client && (
                          <td style={{paddingRight: '20px', verticalAlign: 'top'}}>
                            <div className='fs-6'>
                              <div className='fw-bolder mt-5'>Contractor PO</div>
                              <div className='text-gray-600'>
                                {workOrder?.statusFlow?.myobStatusFlowType === 'purchaseOrder' &&
                                  !workOrder.isParent &&
                                  workOrder?.purchaseOrder}
                              </div>
                              <div className='text-gray-600'>
                                {(workOrder?.statusFlow?.myobStatusFlowType !== 'purchaseOrder' ||
                                  workOrder.isParent) && <i>n/a</i>}
                              </div>
                            </div>
                          </td>
                        )}
                        {user.tenant?.tenantTypeId?.toUpperCase() !== TenantTypeIds.Contractor && (
                          <td style={{paddingRight: '20px', verticalAlign: 'top'}}>
                            <div className='fs-6'>
                              <div className='fw-bolder mt-5'>Client PO</div>
                              <div className='text-gray-600'>
                                {workOrder?.statusFlow?.myobStatusFlowType === 'purchaseOrder' &&
                                  workOrder?.suppliedPurchaseOrder}
                              </div>
                              <div className='text-gray-600'>
                                {workOrder?.statusFlow?.myobStatusFlowType !== 'purchaseOrder' && (
                                  <i>n/a</i>
                                )}
                              </div>
                            </div>
                          </td>
                        )}
                        {user.tenant?.tenantTypeId?.toUpperCase() !== TenantTypeIds.Contractor && (
                          <td style={{paddingRight: '20px', verticalAlign: 'top'}}>
                            <div className='fs-6'>
                              <div className='fw-bolder mt-5'>Sales Order</div>
                              <div className='text-gray-600'>
                                {!workOrder.isParent &&
                                  workOrder?.statusFlow?.myobStatusFlowType === 'salesOrder' &&
                                  workOrder?.salesOrder}
                              </div>
                              <div className='text-gray-600'>
                                {(workOrder.isParent ||
                                  workOrder?.statusFlow?.myobStatusFlowType !== 'salesOrder') && (
                                  <i>n/a</i>
                                )}
                              </div>
                            </div>
                          </td>
                        )}

                        {user.tenant?.tenantTypeId?.toUpperCase() === TenantTypeIds.Owner && (
                          <td style={{paddingRight: '20px', verticalAlign: 'top'}}>
                            <div className='fs-6'>
                              <div className='fw-bolder mt-5'>MYOB PJ</div>
                              <span> {!externalId?.source && <i>Unknown</i>}</span>
                              <span>
                                {' '}
                                {externalId?.source && (
                                  <b>
                                    {externalId?.externalProjectId} (
                                    {sourceFriendlyName(externalId?.source)})
                                  </b>
                                )}{' '}
                                {!externalId.isValid &&
                                  externalId?.source !== 'none' &&
                                  'Warning Project Id is not valid and will not sync to MYOB'}
                              </span>
                            </div>
                          </td>
                        )}
                        {user.tenant?.tenantTypeId?.toUpperCase() === TenantTypeIds.Owner && (
                          <td style={{paddingRight: '20px', verticalAlign: 'top'}}>
                            <div className='fs-6'>
                              <div className='fw-bolder mt-5'>Manufacturing Multiplier</div>
                              <div className='text-gray-600'>
                                {!workOrder.isParent &&
                                  workOrder?.statusFlow?.myobStatusFlowType === 'salesOrder' &&
                                  (workOrder?.manufacturingPercentageFee
                                    ? 1 + workOrder?.manufacturingPercentageFee / 100
                                    : 1.55) +
                                    ' (' +
                                    (
                                      (1 -
                                        1 /
                                          (1 +
                                            (workOrder?.manufacturingPercentageFee ?? 55) / 100)) *
                                      100
                                    ).toFixed(2) +
                                    '% margin)'}
                              </div>
                              <div className='text-gray-600'>
                                {(workOrder.isParent ||
                                  workOrder?.statusFlow?.myobStatusFlowType !== 'salesOrder') && (
                                  <i>n/a</i>
                                )}
                              </div>
                            </div>
                          </td>
                        )}
                        {user.tenant?.tenantTypeId?.toUpperCase() === TenantTypeIds.Owner && (
                          <td style={{paddingRight: '20px', verticalAlign: 'top'}}>
                            <div className='fs-6'>
                              <div className='fw-bolder mt-5'>Shipping Multiplier</div>
                              <div className='text-gray-600'>
                                {!workOrder.isParent &&
                                  workOrder?.statusFlow?.myobStatusFlowType === 'salesOrder' &&
                                  (workOrder?.shippingPercentageFee
                                    ? 1 + workOrder?.shippingPercentageFee / 100
                                    : 1.55) +
                                    ' (' +
                                    (
                                      (1 -
                                        1 / (1 + (workOrder?.shippingPercentageFee ?? 15) / 100)) *
                                      100
                                    ).toFixed(2) +
                                    '% margin)'}
                              </div>
                              <div className='text-gray-600'>
                                {(workOrder.isParent ||
                                  workOrder?.statusFlow?.myobStatusFlowType !== 'salesOrder') && (
                                  <i>n/a</i>
                                )}
                              </div>
                            </div>
                          </td>
                        )}
                      </tr>

                      <tr>
                        <td style={{paddingRight: '20px'}}>
                          <div className='fs-6'>
                            <div className='fw-bolder mt-5'>
                              Created By{' '}
                              <IconTooltip
                                id='user-tooltip'
                                content={userPopover()}
                                placement='right'
                              />
                            </div>
                            <div className='text-gray-600'>
                              {workOrder.createdBy?.name} {workOrder.createdBy?.surname} -{' '}
                              {workOrder.createdBy?.tenant?.name}
                            </div>
                          </div>
                        </td>

                        <td style={{paddingRight: '20px'}}>
                          <div className='fs-6'>
                            <div className='fw-bolder mt-5'>Shipping</div>
                            {workOrder?.statusFlow?.myobStatusFlowType === 'salesOrder' && (
                              <div className='text-gray-600'>
                                {workOrder.shippingType && workOrder.shippingType}
                                {!workOrder.shippingType && 'Other'}
                              </div>
                            )}
                            {workOrder?.statusFlow?.myobStatusFlowType !== 'salesOrder' && (
                              <div className='text-gray-600'>n/a</div>
                            )}
                          </div>
                        </td>

                        {workOrder?.statusFlow?.myobStatusFlowType === 'salesOrder' && (
                          <td style={{paddingRight: '20px'}}>
                            <div className='fs-6'>
                              <div className='fw-bolder mt-5'>Address</div>
                              <div className='text-gray-600'>{workOrder.addressLine1}</div>
                              <div className='text-gray-600'>{workOrder.addressLine2}</div>
                              <div className='text-gray-600'>
                                {workOrder.city} {workOrder.postalCode}
                              </div>
                              <div className='text-gray-600'>{workOrder.country}</div>
                            </div>
                          </td>
                        )}

                        {workOrder?.statusFlow?.myobStatusFlowType === 'salesOrder' && (
                          <td style={{paddingRight: '20px'}}>
                            <div className='fs-6'>
                              <div className='fw-bolder mt-5'>Contact</div>
                              <div className='text-gray-600'>
                                {workOrder.shipToContactAttention}
                              </div>
                              <div className='text-gray-600'>{workOrder.shipToContactNumber}</div>
                              <div className='text-gray-600'>{workOrder.shipToContactEmail}</div>
                            </div>
                          </td>
                        )}

                        {workOrder.onBehalfOfTenantId && (
                          <td style={{paddingRight: '20px'}}>
                            <div className='fs-6'>
                              <div className='fw-bolder mt-5'>Created On Behalf Of</div>
                              <div className='text-gray-600'>
                                {workOrder.onBehalfOfTenant?.name}
                              </div>
                            </div>
                          </td>
                        )}
                        {workOrder.schedule && (
                          <td style={{paddingRight: '20px'}}>
                            <div className='fs-6'>
                              <div className='fw-bolder mt-5'>Schedule</div>
                              <div className='text-gray-600'>
                                <Link to={`/schedules/details/${workOrder.schedule?.id}`}>
                                  {workOrder.schedule?.name}
                                </Link>
                              </div>
                            </div>
                          </td>
                        )}
                        {workOrder.completeDate && (
                          <td style={{paddingRight: '20px'}}>
                            <div className='fs-6'>
                              <div className='fw-bolder mt-5'>Completed Date</div>
                              <div className='text-gray-600'>
                                <Moment utc local format='ddd DD MMM, YYYY h:mm a'>
                                  {workOrder.completeDate}
                                </Moment>
                              </div>
                            </div>
                          </td>
                        )}
                      </tr>

                      <tr>
                        <td>
                          <div className='fs-6'>
                            <div className='fw-bolder mt-5'>Suppress Emails</div>
                            <div className='text-gray-600'>
                              {workOrder.suppressEmails ? 'Yes' : 'No'}
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table style={{width: '100%'}}>
                    <tbody>
                      <tr>
                        <td>
                          <div className='fw-bolder mt-5'>Description</div>

                          <textarea
                            name='description'
                            placeholder=''
                            className='form-control form-control-solid'
                            id='description'
                            disabled
                            rows={3}
                            style={{width: '100%'}}
                            defaultValue={workOrder.description}
                          ></textarea>
                        </td>
                      </tr>
                      {user.tenant?.tenantTypeId?.toUpperCase() !== TenantTypeIds.Client && (
                        <tr>
                          <td>
                            <div className='fw-bolder mt-5'>Contractor Notes</div>

                            <textarea
                              name='contractorNotes'
                              placeholder=''
                              className='form-control form-control-solid'
                              id='contractorNotes'
                              disabled
                              rows={3}
                              style={{width: '100%'}}
                              defaultValue={workOrder.contractorNotes}
                            ></textarea>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <table style={{width: '100%'}}>
                    <tbody>
                      <tr>
                        <td>
                          <div className='fw-bolder mt-5'>WO Contact Name</div>

                          <input
                            type='text'
                            name='contact'
                            placeholder=''
                            className='form-control form-control-solid'
                            id='contact'
                            disabled
                            defaultValue={workOrder.contact}
                          />
                        </td>
                        <td>
                          <div className='fw-bolder mt-5'>WO Contact Number</div>

                          <input
                            type='text'
                            name='contactNumber'
                            placeholder=''
                            className='form-control form-control-solid'
                            id='contactNumber'
                            disabled
                            defaultValue={workOrder.contactNumber}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className='fw-bolder mt-5'>Site Contact Name</div>

                          <input
                            type='text'
                            name='siteContact'
                            placeholder=''
                            className='form-control form-control-solid'
                            id='siteContact'
                            disabled
                            defaultValue={workOrder.siteContact}
                          />
                        </td>
                        <td>
                          <div className='fw-bolder mt-5'>Site Contact Number</div>

                          <input
                            type='text'
                            name='siteContactNumber'
                            placeholder=''
                            className='form-control form-control-solid'
                            id='siteContactNumber'
                            disabled
                            defaultValue={workOrder.siteContactNumber}
                          />
                        </td>
                      </tr>
                      {workOrder.onBehalfOfTenantId && (
                        <tr>
                          <td>
                            <div className='fw-bolder mt-5'>Client Contact</div>

                            <input
                              type='text'
                              name='clientContact'
                              placeholder=''
                              className='form-control form-control-solid'
                              id='clientContact'
                              disabled
                              defaultValue={workOrder.clientContact}
                            />
                          </td>
                          <td></td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {user.tenant?.tenantTypeId?.toUpperCase() === TenantTypeIds.Owner && (
                    <>
                      <div style={{marginTop: '40px', marginBottom: '20px'}}>
                        <h5>Integration Settings</h5>
                        <table>
                          <tbody>
                            <tr>
                              <td style={{paddingRight: '20px', verticalAlign: 'top'}}>
                                <div className='fs-6'>
                                  <div className='fw-bolder mt-5'>Sync Disabled</div>
                                  <div className='text-gray-600'>
                                    <input
                                      type='checkbox'
                                      name='externalSyncDisabled'
                                      value='True'
                                      checked={workOrder?.localOnly}
                                      onClick={async () => {
                                        await updateLocalOnly(!workOrder.localOnly)
                                        await fetchData()
                                      }}
                                    />
                                  </div>
                                </div>
                              </td>

                              <td style={{paddingRight: '20px', verticalAlign: 'top'}}>
                                <div className='fs-6'>
                                  <div className='fw-bolder mt-5'>Data provider</div>
                                  <div className='text-gray-600'>
                                    <span className='badge badge-light-success'>
                                      {workOrder?.dataProvider === 'none' ? 'RD Maintain' : 'MYOB'}
                                    </span>
                                  </div>
                                </div>
                              </td>

                              {!workOrder.localOnly && (
                                <>
                                  {workOrder.externalMYOBProjectTaskId && (
                                    <td
                                      style={{
                                        paddingRight: '20px',
                                        verticalAlign: 'top',
                                      }}
                                    >
                                      <div className='fs-6'>
                                        <div className='fw-bolder mt-5'>Project Task ID</div>
                                        <div className='text-gray-600'>Created</div>
                                      </div>
                                    </td>
                                  )}

                                  {workOrder.externalMYOBProjectRevenueBudgetId && (
                                    <td
                                      style={{
                                        paddingRight: '20px',
                                        verticalAlign: 'top',
                                      }}
                                    >
                                      <div className='fs-6'>
                                        <div className='fw-bolder mt-5'>Revenue Budget ID</div>
                                        <div className='text-gray-600'>Created</div>
                                      </div>
                                    </td>
                                  )}

                                  {workOrder.externalMYOBProjectCostBudgetId && (
                                    <td
                                      style={{
                                        paddingRight: '20px',
                                        verticalAlign: 'top',
                                      }}
                                    >
                                      <div className='fs-6'>
                                        <div className='fw-bolder mt-5'>Revenue Cost ID</div>
                                        <div className='text-gray-600'>Created</div>
                                      </div>
                                    </td>
                                  )}

                                  {workOrder.externalMYOBProjectPOId && (
                                    <td
                                      style={{
                                        paddingRight: '20px',
                                        verticalAlign: 'top',
                                      }}
                                    >
                                      <div className='fs-6'>
                                        <div className='fw-bolder mt-5'>Project PO ID</div>
                                        <div className='text-gray-600'>Created</div>
                                      </div>
                                    </td>
                                  )}

                                  {workOrder.ownerForMyobUser && (
                                    <td
                                      style={{
                                        paddingRight: '20px',
                                        verticalAlign: 'top',
                                      }}
                                    >
                                      <div className='fs-6'>
                                        <div className='fw-bolder mt-5'>Owner</div>
                                        <div className='text-gray-600'>
                                          {workOrder.ownerForMyobUser.name}
                                        </div>
                                      </div>
                                    </td>
                                  )}

                                  <td>
                                    <button
                                      type='button'
                                      className='btn btn-sm btn-primary me-5'
                                      data-bs-toggle='modal'
                                      data-bs-target='#wo_sync_to_myob_modal'
                                      disabled={loading}
                                      onClick={() => setSyncToMYOB(true)}
                                    >
                                      Sync to MYOB
                                    </button>
                                  </td>
                                </>
                              )}
                            </tr>
                          </tbody>
                        </table>

                        <table style={{width: '100%'}}>
                          <tbody>
                            <tr>
                              <td>
                                <div className='fw-bolder mt-5'>Invoice Note (MYOB)</div>

                                <textarea
                                  name='invoiceNote'
                                  placeholder=''
                                  className='form-control form-control-solid'
                                  id='invoiceNote'
                                  disabled
                                  rows={3}
                                  style={{width: '100%'}}
                                  defaultValue={workOrder.invoiceNote}
                                ></textarea>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <ul
                className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder'
                style={loading ? {pointerEvents: 'none'} : {pointerEvents: 'auto'}}
              >
                {!hideChildCostAndNotes && (
                  <li
                    className='nav-item mt-2'
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                      dispatch(Actions.setFilter({...workorder.filter, selectedTab: NavItems.Notes}))
                    }}
                  >
                    <span
                      className={`nav-link text-active-primary ms-0 me-5 py-5 ${
                        selectedTab === NavItems.Notes ? 'active' : ''
                      }`}
                    >
                      Notes ({workOrder.workOrderStats?.notesCount ?? 0})
                    </span>
                  </li>
                )}
                <li
                  className='nav-item mt-2'
                  style={{cursor: 'pointer'}}
                  onClick={() => {
                    dispatch(
                      Actions.setFilter({...workorder.filter, selectedTab: NavItems.Attachments})
                    )
                  }}
                >
                  <span
                    className={`nav-link text-active-primary ms-0 me-5 py-5 ${
                      selectedTab === NavItems.Attachments ? 'active' : ''
                    }`}
                  >
                    Files ({workOrder.workOrderStats?.attachmentsCount ?? 0})
                  </span>
                </li>
                <li
                  className='nav-item mt-2'
                  style={{cursor: 'pointer'}}
                  onClick={() => {
                    dispatch(
                      Actions.setFilter({...workorder.filter, selectedTab: NavItems.Notices})
                    )
                  }}
                >
                  <span
                    className={`nav-link text-active-primary ms-0 me-5 py-5 ${
                      selectedTab === NavItems.Notices ? 'active' : ''
                    }`}
                  >
                    Notices ({workOrder.workOrderStats?.noticesCount ?? 0})
                  </span>
                </li>
                <li
                  className='nav-item mt-2'
                  style={{cursor: 'pointer'}}
                  onClick={() => {
                    dispatch(
                      Actions.setFilter({...workorder.filter, selectedTab: NavItems.CheckLists})
                    )
                  }}
                >
                  <span
                    className={`nav-link text-active-primary ms-0 me-5 py-5 ${
                      selectedTab === NavItems.CheckLists ? 'active' : ''
                    }`}
                  >
                    Check Lists ({workOrder.workOrderStats?.checkListCount ?? 0})
                  </span>
                </li>
                <li
                  className='nav-item mt-2'
                  style={{cursor: 'pointer'}}
                  onClick={() => {
                    dispatch(
                      Actions.setFilter({...workorder.filter, selectedTab: NavItems.Participants})
                    )
                  }}
                >
                  <span
                    className={`nav-link text-active-primary ms-0 me-5 py-5 ${
                      selectedTab === NavItems.Participants ? 'active' : ''
                    }`}
                  >
                    Participants ({workOrder.workOrderStats?.participantsCount ?? 0})
                  </span>
                </li>
                <li
                  className='nav-item mt-2'
                  style={{cursor: 'pointer'}}
                  onClick={() => {
                    dispatch(
                      Actions.setFilter({...workorder.filter, selectedTab: NavItems.CheckIns})
                    )
                  }}
                >
                  <span
                    className={`nav-link text-active-primary ms-0 me-5 py-5 ${
                      selectedTab === NavItems.CheckIns ? 'active' : ''
                    }`}
                  >
                    Check Ins ({workOrder.workOrderStats?.checkInsCount ?? 0})
                  </span>
                </li>
                <li
                  className='nav-item mt-2'
                  style={{cursor: 'pointer'}}
                  onClick={() => {
                    dispatch(Actions.setFilter({...workorder.filter, selectedTab: NavItems.Quotes}))
                  }}
                >
                  <span
                    className={`nav-link text-active-primary ms-0 me-5 py-5 ${
                      selectedTab === NavItems.Quotes ? 'active' : ''
                    }`}
                  >
                    Quotes ({workOrder.workOrderStats?.quotesCount ?? 0})
                  </span>
                </li>
                {user.tenant?.tenantTypeId?.toUpperCase() !== TenantTypeIds.Client &&
                  user.tenant?.tenantTypeId?.toUpperCase() !== TenantTypeIds.Contractor && (
                    <li
                      className='nav-item mt-2'
                      style={{cursor: 'pointer'}}
                      onClick={() => {
                        dispatch(
                          Actions.setFilter({
                            ...workorder.filter,
                            selectedTab: NavItems.Charges,
                          })
                        )
                      }}
                    >
                      <span
                        className={`nav-link text-active-primary ms-0 me-5 py-5 ${
                          selectedTab === NavItems.Charges ? 'active' : ''
                        }`}
                      >
                        Charges ({workOrder.workOrderStats?.chargesCount ?? 0})
                      </span>
                    </li>
                  )}
                {workOrder.isParent &&
                  user.tenant?.tenantTypeId?.toUpperCase() === TenantTypeIds.Owner && (
                    <li
                      className='nav-item mt-2'
                      style={{cursor: 'pointer'}}
                      onClick={() => {
                        dispatch(
                          Actions.setFilter({
                            ...workorder.filter,
                            selectedTab: NavItems.Children,
                          })
                        )
                      }}
                    >
                      <span
                        className={`nav-link text-active-primary ms-0 me-5 py-5 ${
                          selectedTab === NavItems.Children ? 'active' : ''
                        }`}
                      >
                        Project ({cwoCount})
                      </span>
                    </li>
                  )}{' '}
                {permissions?.includes('asset.view.all') && (
                  <li
                    className='nav-item mt-2'
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                      dispatch(
                        Actions.setFilter({
                          ...workorder.filter,
                          selectedTab: NavItems.Assets,
                        })
                      )
                    }}
                  >
                    <span
                      className={`nav-link text-active-primary ms-0 me-5 py-5 ${
                        selectedTab === NavItems.Assets ? 'active' : ''
                      }`}
                    >
                      Assets ({workOrder.assets?.length ?? 0})
                    </span>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <Toaster
            position='top-right'
            toastOptions={{
              className: '',
              style: {
                color: '#009ef7',
                background: '#eff2f5',
                maxHeight: '100px',
                overflow: 'scroll',
              },
            }}
          />
          <div className='row g-5 g-xxl-8'>
            {workOrder && workOrder.id && <div className='col-xl-12'>{renderItems()}</div>}
          </div>
        </div>
      </div>
    </>
  )
}

export default connect(({workorder}: RootState) => ({
  workorder,
}))(WorkOrderDetails)
